<template>
  <div class="select_container" @click="onShow">
    <div class="select_label" :class='[disabled ? "select_disabled" : ""]'>{{vmodel}}</div>
    <img src="../../../assets/image/ic_dropdown@2x.png" style="width: 14px; height: 8px;" v-if="drop"/>


    <b-modal id="modalPopover"
      content-class="md_modal_content"
      centered 
      v-model="modalShow"
      :hide-header=true
      :hide-footer=true>
      <div>
        <MFSelectItem 
          v-for="item in options"
          :item="item"
          :isChecked="item == vmodel"
          :isLast="item == options[options.length - 1]"
          @click="onClick"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>

import MFSelectItem from "../MFSelectItem";

export default {
  name: 'MFSelect',
  props: {
    vmodel: "",
    options: [],
    disabled: false,
    drop: false
  },
  components: {
    MFSelectItem,
  },
  data() {
    return {
      modalShow: false,
    }
  },
  methods: {
    onShow() {
      if (this.disabled) return;
      this.modalShow = true;
    },

    onClick(item) {
      this.modalShow = false;
      this.vmodel = item;
      this.$emit("change", item);
    },
  },
}
</script>

<style scoped lang="scss">
  @import '../../../assets/css/_vars.scss';
  
  .select_label {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  .select_disabled {
    color: #E1E1E1!important;
  }

  .select_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/mf/MFSelect.vue